module.exports = __webpack_public_path__ + "static/media/ic-actions-add-file.ba1705bd.svg";